export * from './app-sidebar-nav.component';



// WEBPACK FOOTER //
// D:/desv/producao/ITN/srvHCWaba/src/app/components/app-sidebar-nav/index.ts